// extracted by mini-css-extract-plugin
module.exports = {"subheader":"index-module--subheader--2Bzku","header":"index-module--header--1IdKv","splash":"index-module--splash--2H6cM","typist":"index-module--typist--2iS_R"};